/**
 * Swym のお気に入りボタンのラベルを「お気に入り」表記へ統一する。
 *
 * Swym はアプリ設定側のテキストを出すため、「ほしい物リストに追加する」/
 * 「ウィッシュリストに追加されました」と表現がゆれる。テーマ側で上書きする。
 *
 * 対応アプリは2系統（[[knowledge_swym_wishlist_button_restyle_traps]] 参照）:
 *   Wishlist Plus（PRD）    : button.swym-add-to-wishlist > span.swym-wishlist-cta
 *   Advanced Wishlist（STG）: button#swym-atw-pdp-button.atw-button > .atw-button-text
 *
 * 追従バーの中では CSS でラベルを隠しているので、同じ DOM を書き換えても影響しない。
 */

const LABEL_DEFAULT = 'お気に入りに追加する';
const LABEL_ADDED = 'お気に入りに追加済み';

const BUTTON_SELECTOR = 'button.swym-add-to-wishlist, button.atw-button';
const TEXT_SELECTOR = '.swym-wishlist-cta, .atw-button-text';
const ADDED_CLASSES = ['swym-added', 'atw-button-added'];

/** @param {Element} button */
function labelFor(button) {
  return ADDED_CLASSES.some((cls) => button.classList.contains(cls)) ? LABEL_ADDED : LABEL_DEFAULT;
}

function applyLabels() {
  for (const button of document.querySelectorAll(BUTTON_SELECTOR)) {
    const want = labelFor(button);

    // アイコンは Advanced Wishlist ではインライン SVG なので、
    // button 自体の textContent は触らずテキスト要素だけ書き換える。
    const textEl = button.querySelector(TEXT_SELECTOR);
    if (textEl && textEl.textContent.trim() !== want) {
      textEl.textContent = want;
    }

    if (button.getAttribute('aria-label') !== want) {
      button.setAttribute('aria-label', want);
    }
    if (button.title && button.title !== want) {
      button.title = want;
    }
  }
}

let queued = false;
function scheduleApply() {
  if (queued) return;
  queued = true;
  requestAnimationFrame(() => {
    queued = false;
    applyLabels();
  });
}

applyLabels();
document.addEventListener('DOMContentLoaded', applyLabels);

// Swym の注入・状態変更（クラス付与とテキストの差し替え）を追う。
// 書き換え後は値が一致するので、この監視でループにはならない。
new MutationObserver(scheduleApply).observe(document.documentElement, {
  childList: true,
  subtree: true,
  characterData: true,
  attributes: true,
  attributeFilter: ['class'],
});

// アプリのスクリプト読み込みが遅れるストアがあるので数回だけ叩き直す。
for (const ms of [300, 800, 1500, 3000, 5000]) {
  setTimeout(applyLabels, ms);
}
